
import { supabase } from '@/integrations/supabase/client';

// Admin functions
export interface AdminUser {
  id: string;
  username?: string | null;
  email?: string | null;
}

// Delete a user (for admin use)
export const deleteUser = async (userId: string): Promise<boolean> => {
  try {
    // First update user profile to mark as deleted
    const { error: profileError } = await supabase
      .from('profiles')
      .update({ 
        is_blocked: true,
        // Add a flag or comment to indicate this user was deleted
        username: null, // Set username to null to avoid unique constraint violation
        email: null,
        full_name: null,
        phone_number: null,
        profile_image: null
      })
      .eq('id', userId);
    
    if (profileError) {
      console.error("Error updating profile for deactivation:", profileError);
      return false;
    }
    
    // Now anonymize user data in listings
    const { error: listingsError } = await supabase
      .from('listings')
      .update({
        title: '[Deleted]',
        description: 'This listing\'s creator has been removed from the platform.',
        images: []
      })
      .eq('user_id', userId);
    
    if (listingsError) {
      console.error("Error anonymizing listings for deactivated user:", listingsError);
      // Continue anyway - we've at least updated the profile
    }
    
    return true;
  } catch (error) {
    console.error("Unexpected error during user deactivation:", error);
    return false;
  }
};

